const showMobilMainFace = () => {

	let MobilMainFace = document.querySelector('.mobil-link'),
		link = document.querySelectorAll('.mobil-link a');

	if (MobilMainFace) {
		
		link.forEach((item) => {			
			item.addEventListener('click', (e) => {
				//e.preventDefault();
			});			
		});

		document.addEventListener('click', () => {

			MobilMainFace.classList.toggle('hide');


		});
	}
}
export default showMobilMainFace;